
/**
 * 
 * @param d 格式化距离
 * @returns 
 */
export const distanceFormat = (d: number) => {
  if (d < 1000) {
    return `${d}m`
  }
  if (d > 10000) {
    return ` ${Math.round(d / 1000)}km`
  }
  return `${(d / 1000).toFixed(1)}km`
}
